export enum PageType {
  Website = 'website',
  Front = 'front',
  TickerRatings = 'ticker-ratings',
  Story = 'story',
  Channel = 'channel',
  Topic = 'topic',
  Ticker = 'ticker',
  Tool = 'tool',
  Calendar = 'calendar',
  Evergreen = 'evergreen',
}

export interface SpeakableSpecification {
  '@type': 'SpeakableSpecification';
  cssSelector?: string[];
  xpath?: string[];
}

export interface BreadcrumbTrailItem {
  name: string;
  url: string;
}

export interface StructuredDataI {
  articleBody?: string;
  about?: {
    '@type': string;
    name: string;
    tickerSymbol: string;
    url: string;
  };
  articleSection?: string | null;
  breadcrumb?: BreadcrumbTrailItem[];
  keywords?: string[];
  mainEntity?: string | Record<string, unknown>;
  mentions?: Record<string, unknown>[];
  video?: Record<string, unknown>;
  omitDates?: boolean;
  pageType?: string;
  speakable?: string | SpeakableSpecification;
}

export interface Dimensions {
  authorName?: string;
  contentType: string;
  channels?: string[];
  isBZisBZPRO?: boolean;
}

export type UrlMeta = URL | string | null;

export interface MetaProps {
  author?: string;
  authorId?: number;
  authorType?: string | null;
  authorURL?: string;
  canonical?: string | null;
  css?: string;
  dateCreated?: string | null;
  dateUpdated?: string | null;
  description: string;
  dimensions?: Dimensions;
  hrefLanguage?: string;
  image?: UrlMeta;
  js?: string;
  ogDescription?: string | null;
  ogImage?: UrlMeta;
  ogImageHeight?: number;
  ogImageWidth?: number;
  ogTitle?: string;
  ogType?: string;
  ogVideoUrl?: string;
  robots?: string | null;
  shortUrl?: UrlMeta;
  structuredData?: StructuredDataI | null;
  symbol?: string;
  title: string;
  twitterDescription?: string | null;
  twitterImage?: UrlMeta;
  twitterTitle?: string;
  vertical?: string[];
  pageType?: PageType;
  twitterCard?: 'summary' | 'summary_large_image' | 'app' | 'player';
  referer?: string;
  trackMeta?: boolean;
  subTitle?: string;
  schema?: Record<string, unknown> | null;
  language?: string;
  translations?: Record<string, unknown> | null;
  host?: string;
  isNotAccessibleForFree?: boolean;
  disablePageAndCompanyStructuredData?: boolean;
  // TODO: Temporary for the BZ App Router migration. Remove after the remaining apps stop relying on Meta for global schemas.
  disableGlobalStructuredData?: boolean;
}

export type OpenGraphType =
  | 'article'
  | 'book'
  | 'music.song'
  | 'music.album'
  | 'music.playlist'
  | 'music.radio_station'
  | 'profile'
  | 'website'
  | 'video.tv_show'
  | 'video.other'
  | 'video.movie'
  | 'video.episode';

export interface Paywall {
  active: boolean;
  hasAccess: boolean;
  paywallStyle: string;
}
